import * as type from './constant';

export const getTask = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getTaskSuccess = (payload, month, selfRole='') => ({
  type: type.GET_SUCCESS,
  payload,
  month,
  selfRole,
});

export const getTaskError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addTask = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addTaskSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateTask = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateTaskSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteTask = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteTaskSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const cancelTask = (id, selfRole = undefined) => ({
  type: type.CANCEL,
  id,
  selfRole,
});

export const cancelTaskSuccess = (payload) => ({
  type: type.CANCEL_SUCCESS,
  payload,
});

export const cancelAsignee = (id, asigneeId, selfRole = undefined) => ({
  type: type.CANCEL_ASIGNEE,
  id,
  asigneeId,
  selfRole,
});

export const cancelAsigneeSuccess = (payload) => ({
  type: type.CANCEL_ASIGNEE_SUCCESS,
  payload,
});

export const manipulationTaskError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
